import { FC } from 'react';
import { Box, Tooltip } from '@robocorp/components';
import { IconBolt } from '@robocorp/icons/iconic';
import { AvatarIcon } from '../old-ds-components';

type OwnProps = {
  meta: { apiKeyName?: string; apiKeyId?: string };
  size?: 'small' | 'medium' | 'big';
  shape?: 'square' | 'rounded' | 'circle';
};
type Props = OwnProps;

const ApiAvatar: FC<Props> = ({ meta }) => (
  <Box display="flex">
    <Tooltip text={meta.apiKeyName}>
      <AvatarIcon variant="blue" placeholder={<IconBolt />} />
    </Tooltip>
    <Box display="flex" alignSelf="center" ml={12} />
  </Box>
);

ApiAvatar.defaultProps = {
  size: 'small',
};

export default ApiAvatar;
